import { modelConfiguratorActions, translate } from '../../services';
import { messageDispatcher } from '..';

const addMessage = ( dispatch, message, insertions ) => {
  messageDispatcher( dispatch ).addMessage( { timeout: 3000, messageType: 'confirmation', messageText: translate( message, insertions ) } );
};

export const modelConfiguratorDispatcher = dispatch => ( {
  addToQuantityList: ( productCode, amount ) => dispatch( { type: modelConfiguratorActions.ADD, item: productCode, amount } ),

  setNewAmountToQuantityList: (initialState,productCode, amount ) => dispatch( { type: modelConfiguratorActions.SETAMOUNT, initialState, item: productCode, amount } ),

  resetQuantityList: ( ) => dispatch( { type: modelConfiguratorActions.RESET } ),
} );
